module.exports = __webpack_public_path__ + "img/113.305a7a9d.png";